module.exports = __webpack_public_path__ + "static/media/small-final.78241721.svg";